import {
  ArchiveIcon,
  BellIcon,
  CellSignalFullIcon,
  ChatsCircleIcon,
  LogoutIcon,
  SparkleIcon,
  TrashIcon,
  UserCircleIcon,
  WalletIcon,
} from '../../components/icons';
import { E_Route } from '@repo-sapiens/constants';
import { DeactivateDialog, DeleteDialog, SignoutDialog } from './components';

export const SETTING_MENU = [
  {
    label: 'Settings',
    items: [
      {
        label: 'Notifications',
        id: '1',
        link: E_Route.Notifications,
        Icon: BellIcon,
        CustomComponent: undefined,
      },
      {
        label: 'Services',
        id: '2',
        link: E_Route.Services,
        Icon: CellSignalFullIcon,
        CustomComponent: undefined,
      },
      {
        label: 'Assistant setup',
        id: '3',
        link: E_Route.MeetingBotSetting,
        Icon: SparkleIcon,
        CustomComponent: undefined,
      },
      {
        label: 'My info',
        id: '4',
        link: E_Route.MyAccount,
        Icon: UserCircleIcon,
        CustomComponent: undefined,
      },
    ],
  },
  {
    label: 'Account',
    items: [
      {
        label: 'Billing',
        id: '4',
        Icon: WalletIcon,
        link: E_Route.ManageBilling,
        CustomComponent: undefined,
      },
      {
        label: 'Deactivate Account',
        id: '1',
        Icon: ArchiveIcon,
        CustomComponent: DeactivateDialog,
      },
      {
        label: 'Delete Account',
        id: '2',
        Icon: TrashIcon,
        isButton: true,
        CustomComponent: DeleteDialog,
      },
      {
        label: 'Sign Out',
        id: '3',
        Icon: LogoutIcon,
        CustomComponent: SignoutDialog,
      },
      {
        label: 'Contact Us',
        id: '5',
        Icon: ChatsCircleIcon,
        link: 'https://mail.google.com/mail/?view=cm&fs=1&to=hello@multiplayer.work',
        externalLink: true,
        CustomComponent: undefined,
      },
    ],
  },
  {
    label: 'Others',
    items: [
      {
        label: 'Docs',
        id: '1',
        link: 'https://www.multiplayer.work/docs',
        externalLink: true,
        CustomComponent: undefined,
        Icon: undefined,
      },
      {
        label: 'Privacy Policy',
        id: '2',
        link: 'https://www.multiplayer.work/privacy-policy',
        externalLink: true,
        CustomComponent: undefined,
        Icon: undefined,
      },
      {
        label: 'Terms of Service',
        id: '3',
        link: 'https://www.multiplayer.work/terms-of-service',
        externalLink: true,
        CustomComponent: undefined,
        Icon: undefined,
      },
    ],
  },
];
